import {
  GET_PROFILE_INFO_REQUEST,
  GET_PROFILE_INFO_SUCCESS,
  GET_PROFILE_INFO_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  data: null,
  loading: false,
  error: null,
};
export const getProfileReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_PROFILE_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_PROFILE_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_PROFILE_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
